var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99984 0.166664C4.84784 0.166664 0.666504 4.348 0.666504 9.5C0.666504 14.652 4.84784 18.8333 9.99984 18.8333C15.1518 18.8333 19.3332 14.652 19.3332 9.5C19.3332 4.348 15.1518 0.166664 9.99984 0.166664ZM7.4705 13.504L4.11984 10.1533C3.94507 9.97896 3.84685 9.74221 3.84685 9.49533C3.84685 9.24845 3.94507 9.01171 4.11984 8.83733C4.48384 8.47333 5.07184 8.47333 5.43584 8.83733L8.13317 11.5253L14.5545 5.104C14.9185 4.74 15.5065 4.74 15.8705 5.104C16.2345 5.468 16.2345 6.056 15.8705 6.42L8.7865 13.504C8.43184 13.868 7.8345 13.868 7.4705 13.504Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveImg);
export default __webpack_public_path__ + "static/media/saveImg.b596b6deb7b78436798a29c567a4cb52.svg";
export { ForwardRef as ReactComponent };